module.exports = __webpack_public_path__ + "static/media/L Nadine H.4e506f98.jpg";